/**
 * Pending Withdraw View
 */

define(function(require, exports, module) {
    'use strict';
    var PortletView = require('modules/portlet/portlet.view');
    var PendingItemView = require('portlets/cashier/pending/pending.item.view');
    var PendingCollection = require('portlets/cashier/pending/pending.collection');

    require('widgets/accordion.widget');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.options = options;
            this.collection = new PendingCollection();
            this.attachWidget(this.$el.accordion());
        },

        subscribe: function() {
            this.listenTo(this.collection, 'sync destroy', this._updateTotals);
        },

        render: function() {
            this.$el.html(this.tmpl('pending'));

            this._loadTransactions();

            return this;
        },

        _loadTransactions: function() {
            this.collection.fetch()
                .done(this._updateTransactions.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        _updateTransactions: function(response) {
            var fragment = document.createDocumentFragment(),
                transactions = [],
                item;

            this.$('.fn-loading').remove();

            if (transactions = this.collection.parse(response)) {
                transactions.forEach(function(data) {
                    item = new PendingItemView({model: this.collection.get(data.code)}).render();
                    this.childViews.push(item);
                    fragment.appendChild(item.el);
                }, this);

                this.$('.fn-pending-withdraw-list').append(fragment);
            } else {
                this.$('.fn-pending-withdraw-list').append(this._renderNoTransactions());
            }
        },

        _renderNoTransactions: function() {
            return this.tmpl('cashier.error', {
                message: this.translate('playtech.mobile.system.mobile-cashier.pending-withdraw.no.transactions')
            });
        },

        _updateTotals: function() {
            this.$('.fn-pending-withdraw-sum').html(
                window.Playtech.API.formatter.formatCurrency(this.collection.getSum())
            );
        }
    });
});
